import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles((theme) => ({
  controlPanelWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: '#232323',
    width: '100%',
    padding: '4px 8px',
  },
  leftSidePanel: {
    display: 'flex',
  },
  rightSidePanel: {
    display: 'flex',
  },
  firstButton: (isOnMediaPage) => ({
    width: isOnMediaPage ? '80px' : '90px',
    fontSize: '9px',
    margin: '0 5px 0 0 ',
    '@media (max-width: 1600px)': {
      display: isOnMediaPage ? 'none' : 'unset',
    },
  }),
  lastButton: (isOnMediaPage) => ({
    width: isOnMediaPage ? '80px' : '90px',
    fontSize: '9px',
    margin: '0 20px 0 0 ',
    '@media (max-width: 1600px)': {
      display: isOnMediaPage ? 'none' : 'unset',
    },
  }),
  firstLastButtons: {},
  goButton: (isOnMediaPage) => ({
    width: isOnMediaPage ? '20px' : '90px',
    fontSize: '9px',
  }),
  downloadPdf: {},
  pageNumberText: (isOnMediaPage) => ({
    color: theme.palette.primary.main,
    fontSize: isOnMediaPage ? '12px' : '14px',
  }),
  scaleAndSlider: (isOnMediaPage) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 1600px)': {
      display: isOnMediaPage ? 'none' : 'unset',
    },
  }),
  pdfTextFields: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: theme.palette.primary.main,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  zoomInButton: (isOnMediaPage) => ({
    '@media (max-width: 1600px)': {
      display: isOnMediaPage ? 'none' : 'unset',
    },
  }),
  zoomOutButton: (isOnMediaPage) => ({
    '@media (max-width: 1600px)': {
      display: isOnMediaPage ? 'none' : 'unset',
    },
  }),
  zoomNumber: {
    color: theme.palette.primary.main,
  },
}));
